import { Button, Input, Modal, Popover, Radio, Select, Switch, Tag, Typography, message } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
  xboxActiveOrderedListFetch,
  xboxCancelOrder,
  xboxCheckCodes,
  xboxFetchOrderInfo,
  xboxFetchOrderInfoReset,
  xboxGetInventoryOrder,
  xboxGetInventoryOrderNonMgr,
  xboxNonManagerOrderedListFetch,
  xboxOrderedListFetch,
  xboxOrderedListFetchReset,
  xboxStopOrder,
  xboxStopOrderReset,
} from '../../Reducers/xbox';
import Filters from '../Orders/Filters';
import './styles.scss';
import TableOrdered from '../Orders/TableOrdered';
import UserSettingsService from '../../Services/UserSettingsService';
import { momentToUnixRange, dateRangePeriods } from '../../Utils/date';
import useTable from '../../Utils/useTable';
import { Navigate, redirect, useNavigate, useOutletContext } from 'react-router-dom';
import Page404 from '../Page404';
import PrintInvoiceForm from '../../Components/PrintInvoiceForm';
import useBoolean from '../../Utils/useBoolean';
import { CopyOutlined, CreditCardOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { getActiveCurrencyFromLS, setActiveCurrencyToLS } from '../../Services/CoreService';
import { balanceTopUp } from '../../Reducers/balance';
import { copyToClipboard } from '../../Utils/textTools';

/** This is Page */
function XboxOrders() {

  const isManager = useOutletContext();

  const [activeList, setActiveList] = useState("");
  const [transactionsData, setTransactionsData] = useState("");
  const [newInvoiceId, setNewInvoiceId] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [activeCurrency, setActiveCurrency] = useState(() => getActiveCurrencyFromLS());
    
  const handleChangeCurrency = (curr) => {
    setActiveCurrency(curr);
    setActiveCurrencyToLS(curr)
  }

  const {
    list,
    pagination,
    onChange,
    onFilter,
    isLoading,
    fetch,
    filters,
  } = useTable(state => state.xbox[activeList], activeList === "ordered_list" ? xboxOrderedListFetch : activeList === "user_list" ? xboxNonManagerOrderedListFetch : activeList === "active_ordered_list" ? xboxActiveOrderedListFetch : null);

  
  const dispatch = useDispatch();
  const [selectedRow, setSelectedRow] = useState([]);
  const navigate = useNavigate();

  const payload = useSelector(
    (state) => state.core.customer.id,
    shallowEqual
  );

  // const updateList = useCallback(
  //   () => fetch()
  //   [dispatch, fetch]
  // );

  useEffect(() => {
    if (isManager !== null) {
    if (isManager) {
      setActiveList("ordered_list")
    } else {
      setActiveList("user_list")
    }
    }
  }, [isManager])

  useEffect(() => {
      fetch();
  }, [payload]);

  const changeActive = useCallback(
    (e) => {
      e ? setActiveList('active_ordered_list') : setActiveList('ordered_list')
      fetch()
    },
    []
  );

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRow(newSelectedRowKeys);

    const orderedKeys = newSelectedRowKeys.filter((key) => {
      const [id, amount, status] = key.split("_")
      return !["4", "5", "6", "7"].includes(status)
    });

    const ids = orderedKeys.map((key) => {
      const [id] = key.split("_")
      return Number(id)
    })

    setSelectedIds(ids);
  };

  const emptySelectedIds = !selectedIds.length
  const disabledBgColor =  emptySelectedIds ? "rgba(0, 0, 0, 0.04)" : "#4ec21b"
  const disabledColor =  emptySelectedIds ? "rgba(0, 0, 0, 0.25)" : "white"


  const customer = useSelector(
      (state) => state.core.customer,
      shallowEqual
    );

  const isMultiBalance = customer.hasOwnProperty("balances")
  const isNotMultiBalance = customer.hasOwnProperty("balance")

  // console.log(`CUSTOMER: ${JSON.stringify(customer.balance)}`)
  // console.log(`IS MULTI: ${isMultiBalance}`)
  // console.log(`IS NOT MULTI: ${isNotMultiBalance}`)

  const [bal, setBal] = useState(0);
  const [cur, setCur] = useState(activeCurrency);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [amount, setAmount] = useState(null);
  const [wallet, setWallet] = useState(null)

  const { value: visible, setTrue: open, setFalse: close } = useBoolean(false);

  const handleClosePopover = () => {
    close();
  }

  useEffect(() => {
    if (activeCurrency === "USD") {
      setCur("USD")
    } else {
      setCur(activeCurrency)
    }
  }, [activeCurrency])

  useEffect(() => {
    const selectedAmount = selectedRow.reduce((sum, rowKey) => {
      const [orderId, amount, status] = rowKey.split('_');
      return !["4", "5", "6", "7"].includes(status) ? sum + parseFloat(amount) : sum;
    }, 0).toFixed(2)
    // console.log(`Selected amount: ${selectedAmount}`)
  }, [selectedRow])

  const handleSaveBalance = () => {
    const data = { amount: parseFloat(bal), cur }
    dispatch(balanceTopUp(data))
    .then((res) => {
      message.success(`Successful top up on ${data.amount} ${data.cur}`)
      setAmount(data.amount);
      setWallet(res.address)
      setIsModalVisible(true); 
      close()
    })
    .catch((err) => {
      console.log(`Error: ${err}`)
      message.error(`Error top up. Contact admin.`)
    })
  }

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleSeeTransactions = () => {
    setIsModalVisible(false);
    navigate('/replenishments');
  };

  const handleCopyAddress = (amount) => {
    copyToClipboard(amount)
    message.success('Address copied!')
  }

  const content = (
      <div style={{ display: "flex", alignItems: "center" }}>
        <Select
        size='small'
        value={cur}
        options={[
          {label: "USD", value: "USD"}
        ]}
        onChange={(v) => setCur(v)}
        style={{ marginRight: '4px' }}
        />
        <Input addonBefore={"+"} value={bal} type="number" min={0} size="small" onChange={e => setBal(e.target.value)}/>
        <div className="ml-small flex-center">
          <Button
            size='small'
            // type="primary"
            onClick={handleClosePopover}
          >
            Cancel
          </Button>
          <Button
            size='small'
            style={{marginLeft: "8px"}}
            type="primary"
            onClick={handleSaveBalance}
            disabled={bal === 0}
          >
            Proceed
          </Button>
        </div>
      </div>
  );

  return (
    <>
      <Typography.Title>Orders</Typography.Title>
      {
  !!selectedRow.length ? (
    <span style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
      <b>
        <Tag>
          Total {
            selectedRow.reduce((sum, rowKey) => {
              const [orderId, amount, status] = rowKey.split('_');
              return !["4", "5", "6", "7"].includes(status) ? sum + parseFloat(amount) : sum;
            }, 0).toFixed(2)
          } {cur} {"("}
          {
            selectedRow.length
          } orders{")"}
        </Tag>
      </b>
    </span>
  ) : (
    <span style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
      <b>
        <Tag>Total 0 {cur} {"("}No orders selected{")"}</Tag>
      </b>
    </span>
  )
}
      {isManager && <div className='active_filter'>
        <Switch 
        checkedChildren="All customers"
        unCheckedChildren="See all customers"
        loading={isLoading} 
        onChange={changeActive}
        />
      </div>}
      <div className="currency_btns">
            <Button
                    // size="small"
                    // loading={isLoading}
                    onClick={() => handleChangeCurrency("EUR")}
                    type="primary"
                    className={`currency_btn ${activeCurrency === "EUR" ? "active": ""}`}
                    style={{marginRight: '12px'}}
                    // block
                  >
                    EUR
            </Button>
            <Button
                    // size="small"
                    // loading={isLoading}
                    onClick={() => handleChangeCurrency("USD")}
                    type="primary"
                    className={`currency_btn ${activeCurrency === "USD" ? "active": ""}`}
                    // block
                  >
                    USD
            </Button>
            </div>
      <Filters
        activeCur={activeCurrency}
        className="mb"
        fetchList={fetch}
        changeActive={changeActive}
        activeList={activeList}
        isLoading={isLoading}
        setFiltersAndQuery={onFilter}
        value={filters}
        setFilters={(filters) =>
          UserSettingsService.setFilters('XBOXOrder', onFilter, filters)
        }
        isManager={isManager}
      />
      {isManager && <><Button disabled={emptySelectedIds} onClick={open} style={{marginBottom: '8px', backgroundColor: disabledBgColor, color: disabledColor}}>Create invoice <PlusCircleOutlined /></Button>
      <PrintInvoiceForm
        close={close}
        visible={visible}
        selectedIds={selectedIds}
        setNewInvoiceId={setNewInvoiceId}
      /></>}

    <Modal
      title="Top Up Successful"
      open={isModalVisible}
      onCancel={() => setIsModalVisible(false)}
      footer={[
        <>
          <Button key="back" onClick={handleOk}>
            Ok
          </Button>
          <Button key="see" type="primary" onClick={handleSeeTransactions}>
          Go to transactions
          </Button>
        </>
            ]}
      >
        <p>Transfer exact amount: {amount} to wallet {wallet} <CopyOutlined onClick={() => handleCopyAddress(wallet)} /></p>
        </Modal>
      {!isManager && cur === 'USD' && <Popover open={visible} content={content} title="Top up balance" trigger="click" placement='right'>
        <Button onClick={open} style={{margin: '8px 0', backgroundColor: "#4ec21b", color: "white"}}>Top Up <CreditCardOutlined /></Button>
      </Popover>}


      <TableOrdered
        fetch={fetch}
        list={list.page}
        isLoading={isLoading}
        pagination={pagination}
        onChange={onChange}
        stateReducer={(state) => state.xbox}
        checkCodes={xboxCheckCodes}
        cancelOrder={xboxCancelOrder}
        getInventoryOrder={isManager ? xboxGetInventoryOrder : xboxGetInventoryOrderNonMgr}
        fetchOrderInfo={xboxFetchOrderInfo}
        stopOrder={xboxStopOrder}
        stopOrderReset={xboxStopOrderReset}
        isManager={isManager}
        setSelectedRow={setSelectedRow}
        selected={selectedRow}
        onSelectChange={onSelectChange}
        activeCurrency={activeCurrency}
      />
    </> 
  );
}

export default XboxOrders;
